import Inputmask from 'inputmask/dist/inputmask.mjs';
// <input data-mask="+7 (999) 999-99-99">
window.applyInputMasks = (inputs) => {
    if (!inputs || inputs.length === 0)
        return;
    [].forEach.call(inputs, (input) => {
        const mask = input.getAttribute('data-mask');
        const placeholder = input.getAttribute('placeholder') || 'DD.MM.YYYY';
        if (mask) {
            if (mask === 'date') {
                Inputmask({ alias: 'datetime', inputFormat: 'dd.mm.yyyy', placeholder }).mask(input);
            }
            else if (mask === 'year') {
                Inputmask({ alias: 'datetime', inputFormat: 'yyyy', placeholder }).mask(input);
            }
            else {
                Inputmask({ mask }).mask(input);
            }
        }
    });
};
window.applyInputMasks(document.querySelectorAll('input[data-mask]'));
